import { Amplify } from 'aws-amplify';
// import { fetchAuthSession } from '@aws-amplify/core';
import { getCurrentUser, fetchAuthSession, AuthUser, JWT, signInWithRedirect, signOut as doSignOut, fetchUserAttributes } from 'aws-amplify/auth'
// import { CognitoUser, CognitoAccessToken } from 'amazon-cognito-identity-js';
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import { SIGN_IN } from '../common/paths';
import { AmplifyConfigAuth } from '../config/auth';
import { AmplifyConfigAPI } from '../config/api';

Amplify.configure({
    Auth: AmplifyConfigAuth,
    API: AmplifyConfigAPI,
});

interface IUser {
    username? : string;
    firstname? : string;
    surname? : string;
}

interface UseAuth {
    isLoading: boolean;
    isAuthenticated: boolean;
    user: AuthUser;
    signIn: () => Promise<Result>;
    signOut: () => void;
    getUser: () => Promise<IUser | undefined>;
    getAccessToken: () => Promise<JWT | undefined>;
}

interface Result {
    success: boolean;
    message: string;
    insufficientPermissions?: boolean;
    passwordChangeRequired?: boolean;
    session?: any;
}

type Props = {
    children?: React.ReactNode;
};

const authContext = createContext({} as UseAuth);

export const AuthProvider: React.FC<Props> = ({ children }) => {
    const auth = useProvideAuth();
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        
        if (!auth.isLoading && !auth.isAuthenticated) {
            auth.signIn();
        } else {
            
        }
    }, [location, auth, auth.isAuthenticated, auth.isLoading, navigate])
    return <authContext.Provider value={auth}> {children} </authContext.Provider>;
};

export const useAuth = () => {
    return useContext(authContext);
};

const useProvideAuth = (): UseAuth => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState<any>();

    const checkPermissions = useCallback(async (): Promise<boolean> => {
        const accessToken = await getAccessToken();

        if (accessToken !== undefined) {
            Amplify.configure({
                Auth: AmplifyConfigAuth,
                API: AmplifyConfigAPI,
            },{
                API: {
                  REST: {
                    headers: async () => {
                      return { Authorization: 'Bearer ' + accessToken.toString() };
                    }
                  }
            }});
            return true;
        }

        return false;
    }, []);

    useEffect(() => {
        getCurrentUser()
            .then((result : any) => {
                setUser(result);
                setIsAuthenticated(true);
                checkPermissions().finally(() => setIsLoading(false));
            })
            .catch(() => {
                setUser(undefined);
                setIsAuthenticated(false);
                setIsLoading(false);
            });
    }, [checkPermissions]);

    const signIn = async () => {
        await signInWithRedirect({ provider: {custom: 'tuiad.net'}});

        let user = await getCurrentUser();
        let credentials = await fetchAuthSession();
        if(user !== undefined) {
            console.info(user);
            console.info(credentials);
        }
        return {
            success: true, message: 'TEST'
        };
    }
    
    const signOut = async () => {
        try {
            setIsLoading(true);

            await doSignOut();
            setUser(undefined);
            setIsAuthenticated(false);
            setIsLoading(false);
            return { success: true, message: '' };
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            return {
                success: false,
                message: 'Sign out failed',
            };
        }
    };

    const getUser = async () => {
        try {
            let user = await fetchUserAttributes();
            let result : IUser = {
                firstname: user.given_name,
                surname : user.name,
                username: user.email
            }

            return result;
        } catch {
            return undefined;
        }

    };;

    const getAccessToken = async (): Promise<JWT | undefined> => {
        const session = await fetchAuthSession();
        
        return await session.tokens?.accessToken;
    };

    return {
        isLoading,
        isAuthenticated,
        user,
        signIn,
        signOut,
        getUser,
        getAccessToken
    };
};
